export enum TimeRange {
  EVENT = "Event",
  //WEEK = "Week",
  MONTH = "Month"
}
